
<div class="offer-container">
    <!-- <div class="offer-text" [innerHTML]="'CREDITS.TEXT_HTML' | translate"></div> -->
    <div class="offer-text">
        <div class="pb-5"><b>Oferta specială de lansare platformă AgribusinessJob.com: Publicați 3 Joburi Gratuit!</b></div>
        <div class="pb-5"><b>Perioada: 1 iunie - 1 septembrie 2024</b></div>
        <div class="pb-5">
            Cu ocazia lansării, AgribusinessJob oferă companiilor din domeniul agri-zoo-vet-food
            posibilitatea să posteze gratuit 3 anunțuri de angajare pentru specialiști juniori, specialiști
            seniori și top manageri. Această ofertă specială este valabilă în perioada <b>1 iunie - 1 septembrie!</b>
        </div>
        <div><b><span class="fas fa-star"></span> Cum funcționează?</b></div>
        <ol>
            <li>Înregistrați-vă pe platforma AgribusinessJob între 1 iunie și 1 septembrie.</li>
            <li>Publicați 3 anunțuri de joburi gratuit, care vor rămâne active timp de 3 luni.</li>
            <li>Găsiți cei mai buni candidați pentru pozițiile dvs. vacante, utilizând instrumentele noastre de filtrare și evaluare.</li>
        </ol>
        <div><b><span class="fas fa-phone"></span> Nevoia de suport suplimentar?</b></div>
        <div class="pb-5">Dacă aveți nevoie de suport suplimentar, ne puteți contacta la adresa info@agribusinessjob.com sau pe pagina de contact a acestui website.</div>
        <div><b><span class="fas fa-seedling"></span> Alăturați-vă comunității AgribusinessJob!</b></div>
        <div class="pb-5">Vă invităm să construim împreună o comunitate de specialiști în sectorul agri-food din România!</div>
        <div><b>Marius Ogrezeanu,</b></div>
        <div><b>Fondator Agribusinessjob</b></div>
        <div><b>(+)40723 266 100</b></div>
        
    </div>
</div>
<div class="pricing-area pt-100">
    <div class="container">
        <div class="row">

            <div class="col-sm-6 col-lg-6">
                <div class="premium-card pricing-item wow fadeInUp min-width" data-wow-delay=".3s">
                    <span>{{'CREDITS.PERSONALIZE' | translate}}</span>
                    <p>{{'CREDITS.PERSONALIZE_TEXT' | translate}}</p>
                    <a *ngIf="this.userIsClient" class="round-button white-background mt-5" [routerLink]="['/contact']" target="_blank">Contact</a>
                </div>
            </div>

            <div class="col-sm-6 col-lg-6">
                <div class="standard-card pricing-item wow fadeInUp min-width" data-wow-delay=".3s">
                    <span>START</span>
                    <h2>{{'CREDITS.START_PRICE' | translate}}</h2>
                </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="standard-card pricing-item wow fadeInUp min-width" data-wow-delay=".3s">
                    <span>{{'CREDITS.BASIC' | translate}}</span>
                    <h2>500 Lei</h2>
                    <!-- (click)="loadPayment(1)" -->
                    <a *ngIf="this.userIsClient" class="round-button white-background mt-5">{{'CREDITS.BUY' | translate}}</a>
                </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="business-card pricing-item wow fadeInUp min-width"  data-wow-delay=".3s">
                    <span>BUSINESS</span>
                    <h2>1000 Lei</h2>
                    <!-- (click)="loadPayment(2)" -->
                    <a *ngIf="this.userIsClient"  class="round-button white-background mt-5">{{'CREDITS.BUY' | translate}}</a>
                </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="premium-card pricing-item wow fadeInUp min-width"  data-wow-delay=".3s">
                    <span>PREMIUM</span>
                    <h2>1500 Lei</h2>
                    <!-- (click)="loadPayment(3)" -->
                    <a *ngIf="this.userIsClient"  class="round-button white-background mt-5">{{'CREDITS.BUY' | translate}}</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div align="center" *ngIf="paymentReady">
    <form ACTION="https://secure.euplatesc.ro/tdsprocess/tranzactd.php" METHOD="POST" name="gateway" target="_self">
        <p class="tx_red_mic">Transferring to EuPlatesc.ro gateway</p>
        <p><img src="https://www.euplatesc.ro/plati-online/tdsprocess/images/progress.gif" alt="" title="" onload="javascript:document.gateway.submit()"></p>

        <!-- begin billing details -->
        <input name="fname" type="hidden" value="nume" />
        <input name="lname" type="hidden" value="prenume" />
        <input name="country" type="hidden" value="tara" />
        <input name="company" type="hidden" value="company" />
        <input name="city" type="hidden" value="city" />
        <input name="add" type="hidden" value="adresa" />
        <input name="email" type="hidden" value="email" />
        <input name="phone" type="hidden" value="telefon" />
        <input name="fax" type="hidden" value="fax" />
        <!-- snd billing details -->

        <!-- daca detaliile de shipping difera -->
        <!-- begin shipping details -->
        <input name="sfname" type="hidden" value="nume" />
        <input name="slname" type="hidden" value="prenume" />
        <input name="scountry" type="hidden" value="tara" />
        <input name="scompany" type="hidden" value="company" />
        <input name="scity" type="hidden" value="city" />
        <input name="sadd" type="hidden" value="add" />
        <input name="semail" type="hidden" value="email" />
        <input name="sphone" type="hidden" value="telefon" />
        <input name="sfax" type="hidden" value="fax" />

        <!-- end shipping details -->

        <input type="hidden" NAME="amount" value="1.00" SIZE="12" MAXLENGTH="12" />
        <input TYPE="hidden" NAME="curr" value="RON" SIZE="5" MAXLENGTH="3" />
        <input type="hidden" NAME="invoice_id" value="00012" SIZE="32" MAXLENGTH="32" />
        <input type="hidden" NAME="order_desc" value="Test order" SIZE="32" MAXLENGTH="50" />
        <input TYPE="hidden" NAME="merch_id" SIZE="15" value="testaccount" />
        <input TYPE="hidden" NAME="timestamp" SIZE="15" value="20190101000000" />
        <input TYPE="hidden" NAME="nonce" SIZE="35" value="f7d93357a7040619bc416881c479687f" />
        <input TYPE="hidden" NAME="fp_hash" SIZE="40" value="7c92021205130ab01aaa014e4b47222a" />
        <p><a href="javascript:gateway.submit();" class="txtCheckout">Go Now!</a></p>
    </form>
</div>
